export default "__VITE_ASSET__182720e1__"